import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickPreloadedOrder } from './one-click-profiles.selector';

export const getOneClickJobsitesState = createSelector(
  getOneClickState,
  state => state.jobsiteState,
);

export const getOneClickJobsites = createSelector(
  getOneClickJobsitesState,
  state => state.jobsitesAvailable,
);

export const getOneClickSelectedJobsite = createSelector(
  getOneClickJobsitesState,
  state => state.selected,
);

export const getOneClickStdLot = createSelector(
  getOneClickJobsitesState,
  state => ({
    stdLot: state.stdLot,
    loading: state.loadingStdLot,
  }),
);

export const jobsitesWithPreload = createSelector(
  getOneClickJobsites,
  getOneClickPreloadedOrder,
  (jobsites, preloadedOrder) => ({ jobsites, preloadedOrder }),
);

export const getOneClickJobsiteSalesArea = createSelector(
  getOneClickJobsitesState,
  state => state.salesArea,
);
